export default "__VITE_ASSET__DZs$Fili__"